<template>
  <v-card color="mt-3-n" flat tile class="mb-6">
    <v-toolbar dense class="py-1" elevation="0">
      <v-btn icon @click="backToOrganizationsList">
        <v-icon class="info--text font-weight-bold">mdi-keyboard-backspace</v-icon>
      </v-btn>

      <v-toolbar-title class="info--text font-weight-bold text--darken-1">
        <v-breadcrumbs :items="items" large>
          <template v-slot:divider>
            <v-icon color="info">mdi-chevron-right</v-icon>
          </template>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item @click="changeOrganization(item)" style="cursor: pointer;">
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot="{ hover }">
            <v-btn :class="{ 'success--text' : hover }" icon v-bind="attrs" v-on="on" @click="loadBranches">
              <v-icon color="success">mdi-source-branch-sync</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <span class="text-caption">Branches</span>
      </v-tooltip>

      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot="{ hover }">
            <v-btn :class="{ 'info--text' : hover }" icon v-bind="attrs" v-on="on" @click="loadVisits">
              <v-icon color="info">mdi-calendar-account</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <span class="text-caption">Schedule Visit</span>
      </v-tooltip>

      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot="{ hover }">
            <v-btn :class="{ 'info--text' : hover }" icon v-bind="attrs" v-on="on" @click="loadUsers">
              <v-icon color="info">mdi-account-group</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <span class="text-caption">Users</span>
      </v-tooltip>

      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot="{ hover }">
            <v-btn :class="{ 'red--text' : hover }" icon v-bind="attrs" v-on="on" @click="loadLocation">
              <v-icon color="red">mdi-map-marker</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <span class="text-caption">Location</span>
      </v-tooltip>
    </v-toolbar>
    <v-divider class="mt-4"></v-divider>
    
    <ScheduleVisit v-if="scheduleVisit" :organization="organization"></ScheduleVisit>
    <Users v-if="showUsers" :organization="organization"></Users>
    <Location v-if="showLocation" :organization="organization"></Location>
    <Branches v-if="showBranches" :organization="organization" @select_organization="selectOrganization" :selectedOrganization="selectedOrganization"></Branches>
  </v-card>
</template>

<script>
import ScheduleVisit from './ScheduleVisit.vue';
import Location from './Location.vue';
import Users from './Users.vue';
import Branches from './Branches.vue';

export default {
  components: { 
    Users, 
    Location, 
    ScheduleVisit,
    Branches
  },
  name : "Dashboard",
  props : [
    'organization',
    'tabId',
  ],
  data () {
    return {
      scheduleVisit: true,
      showUsers: false,
      showLocation: false,
      showBranches: false,
      showDepartments: false,
      items: [
        {
          text: 'Dashboard',
          disabled: false,
        },
      ],
      selectedOrganization: {},
    }
  },
  mounted() {
    if (this.tabId == 4) {
      this.scheduleVisit = false;
      this.showBranches = true;
    }

    this.$nextTick(() => {
      this.items = [];

      this.items.push({
        id: this.organization?.id,
        text: this.organization?.legal_name,
        disabled: false,
      });
    });
  },
  methods : {
    backToOrganizationsList() {
      this.$emit('goToOrganizationsList', 'Come Back');
    },
    loadVisits() {
      this.scheduleVisit = true;
      this.showUsers = false;
      this.showLocation = false;
      this.showBranches = false;
    },
    loadBranches() {
      this.scheduleVisit = false;
      this.showUsers = false;
      this.showLocation = false;
      this.showBranches = true;
    },
    loadLocation() {
      this.showLocation = true;
      this.showUsers = false;
      this.scheduleVisit = false;
      this.showBranches = false;
    },
    loadUsers() {
      this.showLocation = false;
      this.showUsers = true;
      this.scheduleVisit = false;
      this.showBranches = false;
    },
    selectOrganization(payload) {
      if (payload.selectedTabId == 2) {
        this.loadVisits();
      }

      this.$emit('select_organization', payload);
      this.changeOrganizations(payload.selectedOrganization);
    },
    changeOrganization(e) {
      let index = -1;
      index = this.items.findIndex((item) => item.id == e.id);
      if (index > -1) {
        this.$nextTick(() => {
          this.selectedOrganization = Object.assign(this.selectedOrganization, {});
          this.selectedOrganization = this.items[index];
          this.items.splice(++index, (this.items?.length - 1));
          this.$emit('select_organization', { selectedTabId: 4, selectedOrganization: this.selectedOrganization });
        });
      }
    },
    changeOrganizations(organization) {
      this.items.push({
        id: organization?.id,
        text: organization?.legal_name,
        disabled: false,
      });
    },
  },
}
</script>